import React from 'react';
import { useIntl } from 'react-intl';
import { DayPicker } from './DayPicker';
import { StatusMessage } from './StatusMessage';
import { TripList } from './TripList';

export const TripStep = ({ flow }) => {
  const { formatMessage } = useIntl();
  const { unit, activity, days, dayKey } = flow;

  let zoneNote = formatMessage({ id: 'requestVideo_zone_note' }, { timeZone: unit.timeZone });
  if (unit.usesFallbackZone) zoneNote = formatMessage({ id: 'requestVideo_zone_fallback' });

  if (activity.isLoading) return <StatusMessage id="requestVideo_days_loading" />;
  if (activity.isError) {
    return <StatusMessage id="requestVideo_days_error" tone="error" onRetry={activity.refetch} />;
  }
  if (days.length === 0) return <StatusMessage id="requestVideo_days_none" />;

  return (
    <section className="request-video-section">
      <p className="request-video-note">{zoneNote}</p>
      <DayPicker
        days={days}
        dayKey={dayKey}
        hasPrev={flow.hasPrevDay}
        hasNext={flow.hasNextDay}
        onStep={flow.stepDay}
        onPick={flow.pickDay}
      />
      <h4>{formatMessage({ id: 'requestVideo_trips_title' })}</h4>
      <TripList
        query={flow.tripsQuery}
        timeZone={unit.timeZone}
        selectedId={flow.trip?.id}
        onPick={flow.pickTrip}
      />
    </section>
  );
};
